import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../shared/layout/layout.component';
import { EventComponent } from './partner/event/event.component';
import { AddComponent } from './partner/event/add/add.component';
import { AddPartnerOverviewComponent } from './partner/event/add-overview/add-overview.component'
import { ReservationComponent } from './partner/reservation/reservation.component';
import { ReportComponent } from './partner/report/report.component';
import { ReleaseComponent } from './partner/release/release.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'event', pathMatch: 'full' },
      {
        path: 'event',
        component: EventComponent,
      },
      {
        path: 'event/overview',
        component: AddPartnerOverviewComponent,
      },
      {
        path: 'event/overview/add/:id',
        component: AddComponent,
      },
      {
        path: 'reservation',
        component: ReservationComponent
      },
      {
        path: 'report',
        component: ReportComponent
      },
      {
        path: 'release',
        component: ReleaseComponent
      },
    ]


  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnerRoutingModule { }
